<template>
	<div class="panel_shouyin">
		<div class="titleLine">
			<el-row>
				<el-col :span="2" :offset="22">
					<el-button @click="add" size="mini">新建寄养</el-button>
				</el-col>
			</el-row>
		</div>
		<div class="listLine">
			<el-table :data="tableData" style="width: 100%" height="100%">
				<el-table-column label="单号" width="150">
					<template slot-scope="scope">
						<span>{{scope.row.careId}}</span>
					</template>
				</el-table-column>
				<el-table-column label="服务">
					<template slot-scope="scope">
						{{scope.row.serviceName}}
					</template>
				</el-table-column>
				<el-table-column label="单价" width="70">
					<template slot-scope="scope">
						{{scope.row.servicePrice}}
					</template>
				</el-table-column>
				<el-table-column label="寄养时间" width="260">
					<template slot-scope="scope">
						{{$public.FTime(scope.row.beginDate,'YYYY-MM-DD HH:mm:ss')}}--{{$public.FTime(scope.row.endDate,'YYYY-MM-DD HH:mm:ss')}}
					</template>
				</el-table-column>
				<el-table-column label="活动" width="150">
					<template slot-scope="scope">
						{{scope.row.activityName}}
					</template>
				</el-table-column>
				<el-table-column label="状态" width="60">
					<template slot-scope="scope">
						{{scope.row.status===1?'寄养中':'已结束'}}
					</template>
				</el-table-column>
				<el-table-column label="销售人员" width="100">
					<template slot-scope="scope">
						<span v-for="item in scope.row.serviceMan" :key="item">{{item+' '}}</span>
					</template>
				</el-table-column>
				<!-- <el-table-column label="消费日期" width="100">
					<template slot-scope="scope">
						{{$public.FTime(scope.row.time_info.date,'YYYY-MM-DD')}}
					</template>
				</el-table-column> -->
				<el-table-column label="操作" width="80">
					<template slot-scope="scope">
						<!-- <el-button type="text" @click="seePet(scope.row)">查看</el-button> -->
						<!-- <el-button v-if="scope.row.status===1" type="text" @click="editPet(scope.row)">编辑</el-button> -->
						<el-button v-if="scope.row.status===1" type="text" @click="stopPet(scope.row)">查看</el-button>
					</template>
				</el-table-column>
				<span slot="empty">
					<img src="../../../../assets/img/konging.png" style="width:271px;margin-top:100px;"/>
					<div style="font-size: 16px;color:#999;margin:20px;">这个人什么痕迹都没留下</div>
				</span>
			</el-table>
		</div>
		<div class="pageLine">
			<page :page="page.page" :pageSize="page.pageSize" :total="page.total" @change="changePage"></page>
		</div>
		<jiyangPetSee v-if="drawerJiyangPetSee_state" :curItem="curItem" @close="submit_drawerJiyangPetSee"></jiyangPetSee>
		<jiyangPetEdit v-if="drawerJiyangPetEdit_state" :curItem="curItem" @close="submit_drawerJiyangPetEdit"></jiyangPetEdit>
		<jiyangSee v-if="drawerJiyangSee_state" :curItem="curItem" @close="submit_drawerJiyangSee"></jiyangSee>
		<!-- 结算 -->
		<div v-if="dialogSettlement_state">
			<dialogSettlement :type="'order'" :orderId="curOrder._id" @submit="submit_dialogSettlement"></dialogSettlement>
		</div>
	</div>
</template>
<script>
	import page from "../../../../components/page.vue"
	import jiyangPetSee from "../drawer/jiyangPetSee.vue"
	import jiyangPetEdit from "../drawer/jiyangPetEdit.vue"
	import jiyangSee from "../drawer/jiyangSee.vue"
	import dialogSettlement from "../../../../components/dialog_settlement.vue"
	export default {
		components:{page,jiyangPetSee,jiyangPetEdit,jiyangSee,dialogSettlement},
		data(){
			return{
				page:{
					page:1,
					pageSize:10,
					total:0
				},
				tableData:[],
				// seePet
				drawerJiyangPetSee_state:false,
				// see
				drawerJiyangSee_state:false,
				// editPet
				drawerJiyangPetEdit_state:false,
				curItem:{},
				// 结算
				dialogSettlement_state:false,
				curOrder:{},
			}
		},
		computed:{
			userInfo(){
				if(this.$store.state.mendian.userInfo._id){
					return this.$store.state.mendian.userInfo;
				}else{
					return {
						basic_info:{},
						card_info:{},
						company_info:{},
						operation_info:{},
						pets_info:[],
						club_card:{}
					}
				}
			},
			curPetId(){
				return this.$store.state.mendian.curPetId;
			},
			curPetInfo(){
				return this.$store.getters['mendian/curPetInfo'];
			},
		},
		watch:{
			curPetInfo(){
				this.getTableData()
			}
		},
		mounted(){
			this.getTableData();
		},
		methods: {
			add(){
				this.$store.commit('jiyang/set_type','add')
			},
			seePet(row){
				this.drawerJiyangPetSee_state = true;
				this.curItem = row;
			},
			submit_drawerJiyangPetSee(){
				this.drawerJiyangPetSee_state = false;
			},
			see(row){
				this.drawerJiyangSee_state = true;
				this.curItem = row;
			},
			submit_drawerJiyangSee(){
				this.drawerJiyangSee_state = false;
				this.getTableData();
			},
			changePage(num){
				this.page.page = num;
				this.getTableData();
			},
			editPet(row){
				this.drawerJiyangPetEdit_state = true;
				this.curItem = row;
			},
			submit_drawerJiyangPetEdit(){
				this.drawerJiyangPetEdit_state = false;
				this.getTableData();
			},
			stopPet(row){
				this.drawerJiyangSee_state = true;
				this.curItem = row;
			},
			// 获取寄养列表
			getTableData() {
				let params = {
					"startDate": "",
					"endDate": "",
					"status": 0,
					"depositType": 0,
					"autoDeduct":-1,
					petId:this.curPetId,
					"pageIndex": this.page.page,
					"pageSize": this.page.pageSize,
					"keyword": ""
				}
				let loading = this.$loading()
				this.$http.post('/api/FosterCare/List/Pets', params).then(res => {
					loading.close()
					if (res.code == 0) {
						this.tableData = res.data.data;
						this.page.total = res.data.count;
					}
				})
			},
			// 结算
			submit_dialogSettlement(a){
				this.dialogSettlement_state = false;
				if(a=='cancel'){
					console.log(a)
				}else if(a=='fail'){
					this.$message({
						message: '结算失败',
						type: 'error'
					});
				}else if(a=='success'){
					this.$message({
						message: '结算成功',
						type: 'success'
					});
					this.$store.dispatch("mendian/getUserInfo",this.userInfo._id)
				}
				this.getTableData();
			},
		},
	}
</script>
<style scoped lang="scss">
.panel_shouyin{
	height: 100%;background-color: #fff;padding:52px 0 0;box-sizing: border-box;position: relative;
	.titleLine{
		width:100%;
		background-color: #fff;
		padding:12px 8px 12px;
		box-sizing: border-box;
		position: absolute;
		top:0;
	}
	.listLine{
		height: 100%;padding:0 0px 60px 0px;box-sizing: border-box;
	}
	.pageLine{
		position: absolute;bottom:0;z-index: 1;width:100%;padding:10px;background-color: #fff;box-sizing: border-box;
	}
}
</style>
